import type { FooterColContact } from '../../../types/footer';
import type { Translations } from '../../../types/translations';

export const mapContact = ({
  col,
  index,
  translations,
  instance,
}: {
  col: FooterColContact;
  index: number;
  translations?: Translations;
  instance?: string;
}) => {
  const contact = col.st_elements.value[0];

  return {
    id: index,
    type: 'contact',
    title:
      contact?.st_title ||
      col.st_headline ||
      translations?.[`footer.column.headline.${index + 1}${instance === 'shop' ? '.shop' : ''}`] ||
      '',
    items: contact?.st_text,
    contactDefault: col.st_default_contact,
    showButton: col.st_show_contact_button,
  } as const;
};
